import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=8dc7cce2&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "swiper/dist/css/swiper.css?vue&type=style&index=0&lang=css&"
import style1 from "./Home.vue?vue&type=style&index=1&id=8dc7cce2&scoped=true&lang=css&"
import style2 from "./Home.vue?vue&type=style&index=2&id=8dc7cce2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc7cce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dc7cce2')) {
      api.createRecord('8dc7cce2', component.options)
    } else {
      api.reload('8dc7cce2', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=8dc7cce2&scoped=true&", function () {
      api.rerender('8dc7cce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Home.vue"
export default component.exports